var _linearGradient;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechMageLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 605.87 82.73",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs11"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient11"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#eeb3c3",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop11"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d700ff",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop12"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient11",
    id: "linearGradient12",
    x1: 369.12,
    y1: 60.72,
    x2: 463.85,
    y2: 60.72,
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2",
    style: {
      stroke: "url(#linearGradient12)",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 386.1,43.27 c -1.1,1.74 -2.24,3.46 -3.38,5.17 -1.14,1.73 -2.2,3.6 -3.5,5.22 -1.12,1.4 -2.35,2.55 -2.32,4.5 0.03,1.84 1.2,3.34 2.51,4.52 2.78,2.49 6.61,3.93 10.13,5 4.01,1.21 8.2,1.96 12.35,2.54 8.57,1.2 17.47,1.17 26.07,0.31 7.87,-0.79 16.73,-2.08 23.52,-6.44 1.7,-1.09 3.46,-2.53 4.14,-4.49 0.78,-2.26 -0.25,-3.72 -1.62,-5.41 -1.32,-1.63 -2.39,-3.43 -3.49,-5.21 -1.17,-1.89 -2.42,-3.74 -3.56,-5.65 4.71,1.79 9.5,3.86 13.12,7.47 3.64,3.63 4.79,8.55 1.79,12.96 -2.77,4.07 -7.52,6.63 -11.95,8.48 -4.8,2.01 -9.93,3.37 -15.06,4.23 -10.98,1.85 -22.24,2.05 -33.27,0.55 -5.34,-0.73 -10.64,-1.89 -15.73,-3.69 -4.63,-1.63 -9.36,-3.82 -12.9,-7.29 -1.88,-1.84 -3.44,-4.21 -3.71,-6.88 -0.28,-2.71 0.86,-5.21 2.56,-7.26 1.7,-2.04 3.87,-3.63 6.15,-4.96 2.59,-1.52 5.36,-2.45 8.07,-3.69 h 0.08 z",
    fill: "#d03d0d",
    strokeWidth: 0,
    id: "path2",
    style: {
      display: "inline",
      stroke: "#4aef36",
      strokeOpacity: 1,
      fill: "#c63533",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    id: "g11"
  }, /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    id: "g7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.697,53.68V15.878H1.449v-6.553h54.246v6.553h-22.619v37.801h-8.379Z",
    fill: "#23232f",
    strokeWidth: 0,
    id: "path3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.616,53.68V9.326h45.615v6.553h-37.235v11.088h35.345v6.553h-35.345v13.608h37.235v6.553h-45.615Z",
    fill: "#23232f",
    strokeWidth: 0,
    id: "path4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.272,53.68c-10.081,0-13.924-4.348-13.924-10.711v-22.932c0-6.363,3.843-10.711,13.924-10.711h35.723v6.553h-35.723c-3.78,0-5.544,1.448-5.544,4.095v23.059c0,2.646,1.764,4.095,5.544,4.095h35.723v6.553h-35.723Z",
    fill: "#23232f",
    strokeWidth: 0,
    id: "path5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.034,53.68v-20.161h-36.29v20.161h-8.379V9.326h8.379v17.641h36.29V9.326h8.379v44.354h-8.379Z",
    fill: "#23232f",
    strokeWidth: 0,
    id: "path6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.707,53.68v-31.06l-22.556,31.06h-6.867l-22.618-30.998v30.998h-7.75V9.326h7.812l26.336,36.226,26.209-36.226h7.183v44.354h-7.749Z",
    fill: "#23232f",
    strokeWidth: 0,
    id: "path7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    id: "g8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m439.363,53.68l-22.87-35.722-23.248,35.722h-9.325l29.486-44.354h6.111l29.296,44.354h-9.45Z",
    fill: "#23232f",
    strokeWidth: 0,
    id: "path8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    isolation: "isolate",
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m481.824,53.68c-10.521,0-15.814-3.213-15.814-9.576v-25.202c0-6.363,5.293-9.576,15.814-9.576h34.715v6.553h-34.715c-4.978,0-7.435,1.008-7.435,3.023v25.202c0,2.016,2.457,3.023,7.435,3.023h19.594c4.978,0,7.435-.944,7.435-2.897v-14.743h8.38v14.743c0,6.3-5.293,9.45-15.814,9.45h-19.594Z",
    fill: "#23232f",
    strokeWidth: 0,
    id: "path9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.295,53.68V9.326h45.615v6.553h-37.235v11.088h35.345v6.553h-35.345v13.608h37.235v6.553h-45.615Z",
    fill: "#23232f",
    strokeWidth: 0,
    id: "path10",
    style: {
      fill: "#ffffff",
      fillOpacity: 0.99421966
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechMageLogoWhite);
export default __webpack_public_path__ + "static/media/TechMageLogoWhite.d26fc6c08004fd1de8329dcffc8c36ce.svg";
export { ForwardRef as ReactComponent };